// extracted by mini-css-extract-plugin
export default {"root":"CompanyProfileView_root__WAvEn"};